import { BackIcon } from "@/components/icons/back-icon";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonContent, IonPage, useIonRouter } from "@ionic/react";
import { OnboardingNextFab } from "../../components/onboarding-next-fab";

// Figma viewport: 393 × 852. Each icon is 73.73px.
// Positions stored as percentages of viewport so it scales across devices.
// Each icon orbits its natural position in a slow circle; varied durations and
// negative delays put them at different points in their orbit from the start.
const FOOD_ICONS = [
  { src: "/assets/images/onboarding-personalise/food-2.svg", left: "24.7%", top: "25.7%", duration: "10s", delay: "0s" },
  { src: "/assets/images/onboarding-personalise/food-4.svg", left: "76.3%", top: "37.3%", duration: "13s", delay: "-4s" },
  { src: "/assets/images/onboarding-personalise/food-1.svg", left: "9.7%",  top: "61%",   duration: "11s", delay: "-7s" },
  { src: "/assets/images/onboarding-personalise/food-3.svg", left: "67.3%", top: "60.6%", duration: "12s", delay: "-2s" },
];

const OnboardingPersonaliseIntroPage = () => {
  const { navigateToNextStep, info } = useStepRouteInfo();
  const navigation = useIonRouter();

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="relative h-full bg-white">
          <div className="safe-area-top sticky top-0 z-20 flex items-center bg-white pt-5 pr-9 pb-4 pl-5">
            {info?.previousPath && (
              <button
                type="button"
                aria-label="Go back"
                onClick={() => navigation.push(info.previousPath!, "none", "pop", undefined)}
                className="flex size-11 shrink-0 items-center justify-center"
              >
                <BackIcon />
              </button>
            )}
          </div>
          <style>{`
            @keyframes food-orbit {
              from { transform: rotate(0deg)   translateX(18px) rotate(0deg);    }
              to   { transform: rotate(360deg) translateX(18px) rotate(-360deg); }
            }
          `}</style>

          <div className="to-splash-screen-background/30 pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-b from-transparent" />

          {FOOD_ICONS.map((icon, i) => (
            <img
              key={i}
              src={icon.src}
              alt=""
              className="absolute aspect-square w-[18.7%] max-w-[74px]"
              style={{
                left: icon.left,
                top: icon.top,
                animation: `food-orbit ${icon.duration} linear infinite`,
                animationDelay: icon.delay,
              }}
            />
          ))}

          <div className="absolute top-[41%] left-[9.2%] w-[82%] max-w-[321px]">
            <h2 className="text-[22px] leading-tight font-semibold text-[#6b1fd7]">
              Now let&apos;s personalise
              <br />
              your food preferences
            </h2>
            <p className="pt-3 text-base font-medium text-black w-[82%]">
              So NutriCoach has a better understanding of you
            </p>
          </div>

          <OnboardingNextFab onClick={navigateToNextStep} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default OnboardingPersonaliseIntroPage;
